import React from "react";
import OneVoucherRedemption from ".";

export default function OneVoucherRedemptionExamples() {
  const [error, setError] = React.useState<any>(null);
  return (
    <OneVoucherRedemption
      responseError={error}
      selectedVoucherSubType={{
        name: "Doctor",
        amount: 21900,
        currencyCode: "ZAR",
      }}
      onBackButtonClick={() => console.log("Back")}
      onOneVoucherContinueButtonClick={() => {
        console.log("Continue button clicked");
        setTimeout(() => {
          setError({
            message:
              "It looks like this 1Voucher does not have enough funds. Please choose another payment option to continue.",
          });
        }, 1000);
      }}
    />
  );
}
